import { useEventEffect } from "@cirrus/core/events"
import { useCommonEventBus } from "../../hooks/useCommonEventBus"
import { useUserSettings } from "../context"
import { delay } from "@cirrus/core/utils"

export const InitFromCache = () => {
  
  const bus = useCommonEventBus()
  const settings = useUserSettings()
  
  useEventEffect(bus, "App > UserSettings > InitFromCache", async () => {
    
    if (settings.state.areLoaded) return
    
    if (!sessionStorage) {
      bus.emit("App > UserSettings > Fetch")
      return
    }
    
    let data = sessionStorage.getItem("USER_SETTINGS")
    
    while (!data) {
      data = sessionStorage.getItem("USER_SETTINGS")
      await delay(300)
    }
    
    settings.api.setData(JSON.parse(data))
    bus.emit("App > UserSettings > InitFromCache > Success", data)
  })
  
  return null
}
